export class AppSettings {
  static isProduction(){
    return process.env.NODE_ENV === 'production';
  }
}
